import React from "react";

import MobileHistory from "../MobileHistory/MobileHistory";
import { SENTINEL_TRAILER } from "../../constants/sentinel_types";

export default function TrailerHistory() {
  return <MobileHistory deviceTypeId={SENTINEL_TRAILER} />;
}
